import { FC } from 'react';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Typography from '@mui/material/Typography';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';

import { useAccordionPanel } from 'components/AccordionController';

type Props = {
  id: string;
  title?: string;
  subTitle?: string | null;
};

const Section: FC<Props> = ({ id, title, subTitle, children }) => {
  const [open, change] = useAccordionPanel(id);

  return (
    <Accordion expanded={open} onChange={change}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography sx={{ width: subTitle ? '33%' : '100%', flexShrink: 0 }}>
          {title}
        </Typography>

        {subTitle && (
          <Typography sx={{ color: 'text.secondary' }}>{subTitle}</Typography>
        )}
      </AccordionSummary>

      <AccordionDetails>{children}</AccordionDetails>
    </Accordion>
  );
};

export default Section;
